import { CookieConsentType } from '../types/cookie'

const COOKIE_CONSENT_KEY = 'cookie-consent'
export function getConsent(): CookieConsentType | null {
  if (typeof window === 'undefined') return null

  if (
    !window.location.pathname.includes('/us') || // url에 /us가 포함되지 않으면 모든 쿠키에 동의한 것처럼 동작합니다.
    window.location.pathname.includes('/unni-guide-v2') // url에 /unni-guide-v2가 포함되면 모든 쿠키에 동의한 것처럼 동작합니다.
  ) {
    return {
      isSet: true,
      timestamp: Date.now(),
      settings: {
        performance: true,
        targeting: true,
        functional: true,
        strictlyNecessary: true,
      },
    }
  }

  const stored = localStorage.getItem(COOKIE_CONSENT_KEY)
  if (!stored) return null
  try {
    return JSON.parse(stored) as CookieConsentType
  } catch {
    return null
  }
}

export function isPerformanceConsentGranted() {
  return getConsent()?.settings.performance ?? false
}

export function isTargetingConsentGranted() {
  return getConsent()?.settings.targeting ?? false
}

export function isFunctionalConsentGranted() {
  return getConsent()?.settings.functional ?? false
}

export function isStrictlyNecessaryConsentGranted() {
  return true // 항상 true
}
